import {
  getAdditionalDetails,
  tutorApiService,
} from "../../network/TutorApiService";
import {
  disconnectSocket,
  socketInitialisation,
} from "../../network/SocketOperation";
import { isEmptyOrNull } from "../../utils/common-utils";
import { redirectToLoginPage } from "../login-service";
import { HTTP_CODES } from "../../utils/TutorConstants";

const chatConversation = async (body) => {
  const {
    inputParams,
    setLoader,
    chat_id,
    isSummary,
    setIsCompleted,
    handleStreaming,
    chatIndex,
    handleResponseHeaders,
    handleCompleted,
    setLoaderText
  } = body;
  try {
    console.log("Starting the doubt conversation...");
    socketInitialisation();
    const user_details = await getAdditionalDetails();
    let headers = {};
    headers["x-chat-id"] = chat_id;
    headers["x-chat-index"] = chatIndex;
    headers["x-user-name"] = user_details?.firstName;
    headers["x-mobile"] = user_details?.phoneNumber;

    console.log("Sending request to API...");
    const response = await tutorApiService("/ai-assist/v2/conversation", {
      method: "POST",
      headers,
      body: JSON.stringify(inputParams),
    });

    console.log("Response received from API:", response.status);
    setLoader(false);
    if (response.status == HTTP_CODES.OK || response.status == HTTP_CODES.CREATED) {
      setLoaderText("")
      const reader = response.body.getReader();
      let skip = false;
      if (handleResponseHeaders != undefined) {
        skip = await handleResponseHeaders(response.headers);
        if (skip) {
          return { success: true, status: HTTP_CODES.OK };
        }
      }
      while (true && !skip) {
        const { done, value } = await reader.read();
        if (done) {
          handleCompleted();
          return handleResponse(isSummary, setIsCompleted, response.status);
        }
        if (value instanceof Uint8Array && Array.from(value).includes(4)) {
          return { success: false, status: HTTP_CODES.GAATE_WAY_TIMEOUT };
        } else {
          let chunk = new TextDecoder().decode(value);
          handleUpdateChunk(chunk, isSummary, handleStreaming);
        }
      }
    } else if (response.status == HTTP_CODES.UNAUTHORIZED) {
      redirectToLoginPage();
    } else if (response.status == HTTP_CODES.GAATE_WAY_TIMEOUT) {
      handleCompleted();
      console.log("504 Gateway Timeout error: Server took too long to respond.");
      return handleError(response.status);
    } else {
      isSummary == undefined && setLoader(false);
      return handleError(response.status);
    }
  } catch (err) {
    console.error("Error during fetch request:", err);
    isSummary == undefined && setLoader(false);
    return { success: false, status: HTTP_CODES.GAATE_WAY_TIMEOUT };
  }
};
const handleResponse = (isSummary, setIsCompleted, status) => {
  disconnectSocket();
  if (isSummary == undefined) {
    setIsCompleted(true);
  }
  return { success: true, status: status };
};
const handleError = (statusCode) => {
  disconnectSocket();
  return { success: false, status: statusCode };
};
const handleUpdateChunk = (chunk, isSummary, handleStreaming) => {
  handleStreaming(chunk, isSummary);
};

export { chatConversation };
